/**
 * navigation/appStack.tsx
 * The catalog content as a native-stack. Lateral sidebar navigation, so
 * animation is disabled to match the old instant view-swap. The persistent
 * shell (sidebar/topbar) lives in appShell.tsx around this navigator.
 */

import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

import type { AppStackParamList } from './types';

import Dashboard from '../screens/dashboard';
import AnalyticsScreen from '../screens/analytics';
import ItemsScreen from '../screens/items';
import EditorScreen from '../screens/editor/editor';
import BundlesScreen from '../screens/bundles';
import PriceReviewQueue from '../screens/priceReview';
import TypesView from '../screens/setup/types';
import CategoriesScreen from '../screens/setup/categories';
import CollectionsScreen from '../screens/setup/collections';
import TagsScreen from '../screens/setup/tags';
import LocationsScreen from '../screens/setup/locations';
import WebsiteScreen from '../screens/distribution/website';
import ApiKeysScreen from '../screens/distribution/apiKeys';
import WebhooksScreen from '../screens/distribution/webhooks';
import FeedsScreen from '../screens/distribution/feeds';
import ImportsScreen from '../screens/imports';
import SettingsScreen from '../screens/settings';
import SiteView from '../screens/site';

const Stack = createNativeStackNavigator<AppStackParamList>();

export default function AppStack() {
  return (
    <Stack.Navigator
      initialRouteName="dashboard"
      screenOptions={{ headerShown: false, animation: 'none' }}
    >
      <Stack.Screen name="dashboard" component={Dashboard} />
      <Stack.Screen name="analytics" component={AnalyticsScreen} />
      <Stack.Screen name="items" component={ItemsScreen} />
      <Stack.Screen name="editor" component={EditorScreen} />
      <Stack.Screen name="bundles" component={BundlesScreen} />
      {/* 'bundle' shares the bundles screen (kept for route-name parity). */}
      <Stack.Screen name="bundle" component={BundlesScreen} />
      <Stack.Screen name="pricereview" component={PriceReviewQueue} />
      <Stack.Screen name="types" component={TypesView} />
      <Stack.Screen name="categories" component={CategoriesScreen} />
      <Stack.Screen name="collections" component={CollectionsScreen} />
      <Stack.Screen name="tags" component={TagsScreen} />
      <Stack.Screen name="locations" component={LocationsScreen} />
      <Stack.Screen name="website" component={WebsiteScreen} />
      <Stack.Screen name="site" component={SiteView} />
      <Stack.Screen name="apikeys" component={ApiKeysScreen} />
      <Stack.Screen name="webhooks" component={WebhooksScreen} />
      <Stack.Screen name="feeds" component={FeedsScreen} />
      <Stack.Screen name="imports" component={ImportsScreen} />
      <Stack.Screen name="settings" component={SettingsScreen} />
    </Stack.Navigator>
  );
}
